import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { Alert, Autocomplete } from "@material-ui/lab";

import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { AssignDriverStyle } from "./style";

function AssignDriverPopup(props) {
  const classes = AssignDriverStyle();
  const materialClasses = materialCommonStyles();
  const [scroll] = useState("body");
  const [state] = useStore();

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.customModal}
      scroll={scroll}
    >
      <div className="close-modal">
        <img src={closeIcon} alt="Close" onClick={props.handleClose} />
      </div>
      {props.error && <Alert severity="error">{props.error}</Alert>}
      <DialogTitle id="alert-dialog-title">
        {" "}
        {props.type === "Assign" ? "Assign" : "Re-Assign"} Driver
      </DialogTitle>
      <form
        noValidate
        autoComplete="off"
        className={classes.customForm}
        onSubmit={props.formik.handleSubmit}
      >
        <DialogContent>
          <div className="form-row">
            {!props.isInterstate && (<div className="form-gourp">
              <FormControl variant="outlined" className={classes.formControl}>
                <label className="label-text"></label>
                <Select
                  id="assignDriver"
                  displayEmpty
                  className={materialClasses.customSelect}
                  MenuProps={{
                    classes: {paper: materialClasses.customSelect},
                  }}
                  onChange={props.formik.handleChange("assignDriver")}
                  value={props.formik.values.assignDriver}
                  IconComponent={() => <ExpandMore/>}
                >
                  <MenuItem value={""} disabled>
                    Select Driver
                  </MenuItem>
                  {state?.driver?.gettingLocalDriver ? (
                    <MenuItem>Loading...</MenuItem>
                  ) : (
                    state?.driver?.getLocalDriverData
                      ?.map((itm, indx) => {
                        return (
                          <MenuItem key={indx} value={itm.id}>
                            {itm.name}
                          </MenuItem>
                        );
                      })
                  )}
                </Select>
                <FormHelperText className="error-text">
                  {props.formik.touched.assignDriver &&
                    props.formik.errors.assignDriver}
                </FormHelperText>
              </FormControl>
            </div>)}

            {props.isInterstate && (<div className="form-gourp">
              <FormControl variant="outlined" className={classes.formControl}>
                <label className="label-text"></label>
                <Autocomplete
                  id="assignDriver"
                  popupIcon={<ExpandMore />}
                  className={materialClasses.inputAutoComplete}
                  options={state?.driver?.getInterstateDriverData || []}
                  getOptionLabel={(option) => option.name}
                  value={
                    state?.driver?.getInterstateDriverData?.find((opt) => opt.id === props.formik.values.assignDriver) || null
                  }
                  onChange={props.formik.handleChange("assignDriver")}
                  disableClearable
                  loading={state?.driver?.gettingInterstateDriver}
                  loadingText="Loading..."
                  noOptionsText="No options"
                  renderOption={(option) => (
                    <ul className={materialClasses.dropdownAutoComplete}>
                      <MenuItem
                        key={option.id}
                        value={option.id}

                      >
                        {option.name}
                      </MenuItem>
                    </ul>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      variant="outlined"
                      className="label-text"
                      placeholder={"Search interstate driver"}
                    />
                  )}
                />
                <FormHelperText className="error-text">
                  {props.formik.touched.assignDriver &&
                    props.formik.errors.assignDriver}
                </FormHelperText>
              </FormControl>
            </div>)}
          </div>
        </DialogContent>
        <DialogActions className="bottom-button-block">
          <Button
            className="primary-btn gray-border-btn"
            color="inherit"
            disableElevation
            onClick={props.handleClose}
          >
            CANCEL
          </Button>
          <Button
            className="orange-btn primary-btn center-loading-indicator"
            color="inherit"
            disableElevation
            type="submit"
            disabled={
              state.job?.assigningDriver ||
              state.job?.reAssigningDriver ||
              state.job?.changingDriver ||
              state.job?.reAssigningDriverChange ||
              state.job?.reAssigningConsolidatedJobToDriver ||
              props.isDisableReassign
            }
          >
            {state.job?.assigningDriver ||
              state.job?.reAssigningDriver ||
              state.job?.changingDriver ||
              state.job?.reAssigningConsolidatedJobToDriver ||
              state.job?.reAssigningDriverChange ? (
              <CircularProgress color="inherit" />
            ) : props.type === "Assign" ? (
              "Assign"
            ) : (
              "Re-Assign"
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default AssignDriverPopup;
